/**
 * add-subject-context-relationship-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class AddSubjectContextRelationshipRequest
    extends ReplyVerifyingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.REQ_ADD_SUBJECT_CONTEXT_RELATIONSHIP;
	public static tag : MessageTag = MessageTag.REQ_ADD_SUBJECT_CONTEXT_RELATIONSHIP;

    constructor (
        public relationshipType : string,
        public source : number,
        public sourceRole : string,
        public target : number,
        public targetRole : string
    )
    {
        super();
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/subjects/add-subject-context-relationship-request.ts